export default __webpack_public_path__ + "static/media/calendar.37af33fa.svg";